// Central site configuration for E Telecom.
// Edit contact details, WhatsApp number and links here.

export const SITE = {
  name: "E Telecom",
  tagline: "Powering Smarter Business Communication",
  domain: "etelecom.in",
  // Contact details (provided by client)
  phone: "9852805552",
  phoneDisplay: "+91 98528 05552",
  email: "info@etelecom.in",
  address: "217, Patliputra Colony, Patna - 800013, Bihar, India",
  // Floating WhatsApp CTA — PLACEHOLDER number, update anytime.
  // Use full international format without '+' or spaces.
  whatsappNumber: "919852805552",
  whatsappMessage: "Hi E Telecom, I'd like to know more about your communication solutions.",
};

export const SOLUTIONS = [
  {
    slug: "whatsapp-automation",
    path: "/whatsapp-automation",
    title: "WhatsApp Automation",
    icon: "MessageSquareText",
    short: "Automate customer conversations, notifications, follow-ups and business workflows on WhatsApp.",
    features: [
      "Automated conversations",
      "Customer notifications",
      "Lead follow-ups",
      "Workflow automation",
      "Interactive messaging",
      "Business communication",
    ],
    cta: "Explore WhatsApp Automation",
  },
  {
    slug: "bulk-whatsapp-campaigning",
    path: "/bulk-whatsapp",
    title: "Bulk WhatsApp Campaigning",
    icon: "Send",
    short: "Reach your audience with targeted WhatsApp campaigns designed for marketing, promotions and customer engagement.",
    features: [
      "Campaign management",
      "Contact segmentation",
      "Personalized messaging",
      "Media-rich campaigns",
      "Campaign analytics",
      "Scheduled communication",
    ],
    cta: "Explore WhatsApp Campaigns",
  },
  {
    slug: "bulk-sms",
    path: "/bulk-sms",
    title: "Bulk SMS Services",
    icon: "MessageCircle",
    short: "Deliver important alerts, notifications, promotions and transactional messages quickly and reliably.",
    features: [
      "Promotional SMS",
      "Transactional SMS",
      "OTP messaging",
      "Alerts & notifications",
      "Campaign scheduling",
      "Delivery reporting",
    ],
    cta: "Explore Bulk SMS",
  },
  {
    slug: "smart-telephony",
    path: "/smart-telephony",
    title: "Smart Telephony System",
    icon: "PhoneCall",
    short: "Transform business calling with an intelligent telephony system designed for sales, support and customer communication.",
    features: [
      "Virtual numbers",
      "Cloud telephony",
      "IVR & call routing",
      "Call recording",
      "Agent management",
      "Call analytics",
    ],
    cta: "Explore Smart Telephony",
  },
];

export const SERVICE_OPTIONS = [
  "WhatsApp Automation",
  "Bulk WhatsApp Campaigning",
  "Bulk SMS",
  "Smart Telephony",
  "Multiple Services",
  "Other",
];

// Promotional announcement bar (above header). Edit text/link here.
// Set enabled:false to hide it entirely.
export const ANNOUNCEMENT = {
  enabled: true,
  text: "FREE WhatsApp API for 1 MONTH + FREE Meta Business Verification",
  emoji: "🎁",
  linkTo: "/whatsapp-automation",
  linkLabel: "Claim Offer",
  clickableBar: true,
  dismissible: true,
};

export const VOLUME_OPTIONS = [
  "Less than 10,000 / month",
  "10,000 - 50,000 / month",
  "50,000 - 2,00,000 / month",
  "2,00,000 - 10,00,000 / month",
  "More than 10,00,000 / month",
  "Not sure yet",
];

export const HOME_FAQS = [
  {
    q: "What services does E Telecom provide?",
    a: "E Telecom provides WhatsApp automation, bulk WhatsApp campaigning, bulk SMS and smart telephony solutions — a single platform to connect, engage and automate customer communication.",
  },
  {
    q: "Can I use multiple E Telecom services together?",
    a: "Yes. Businesses can combine communication channels — WhatsApp, SMS and voice — based on their requirements and workflows.",
  },
  {
    q: "Can E Telecom integrate with our existing software?",
    a: "E Telecom can support integration through available APIs, webhooks or supported integrations. Final integration availability depends on the specific system and requirements.",
  },
  {
    q: "Can I send marketing campaigns through WhatsApp?",
    a: "Businesses can use WhatsApp campaign solutions for compliant, permission-based communication, subject to applicable laws, platform policies and consent requirements.",
  },
  {
    q: "Does E Telecom provide cloud telephony?",
    a: "Yes. E Telecom offers a Smart Telephony System for business calling, IVR, call routing, call management and analytics.",
  },
  {
    q: "Can small businesses use E Telecom?",
    a: "Absolutely. Our solutions are designed for startups, SMEs and larger organizations, with plans based on communication requirements.",
  },
];

export const INDUSTRIES = [
  { name: "Real Estate", icon: "Building2", use: "Instant lead follow-ups and site-visit reminders across WhatsApp and calls." },
  { name: "Education", icon: "GraduationCap", use: "Admission enquiries, fee reminders and class notifications at scale." },
  { name: "Healthcare", icon: "HeartPulse", use: "Appointment reminders, reports and OTP-based verifications." },
  { name: "E-commerce", icon: "ShoppingCart", use: "Order updates, abandoned-cart nudges and delivery alerts." },
  { name: "BFSI / Financial", icon: "Landmark", use: "Transactional alerts, OTPs and secure customer communication." },
  { name: "Travel & Hospitality", icon: "Plane", use: "Booking confirmations, itineraries and support conversations." },
  { name: "Automotive", icon: "Car", use: "Service reminders, test-drive follow-ups and sales calling." },
  { name: "Retail", icon: "Store", use: "Promotions, loyalty updates and store notifications." },
  { name: "Professional Services", icon: "Briefcase", use: "Client updates, appointment scheduling and follow-ups." },
  { name: "Startups & SMEs", icon: "Rocket", use: "Affordable multi-channel communication that scales with growth." },
];

export const buildWhatsAppLink = () => {
  const text = encodeURIComponent(SITE.whatsappMessage);
  return `https://wa.me/${SITE.whatsappNumber}?text=${text}`;
};

/**
 * Build a link to the enquiry (contact) workflow with a service (and optional
 * plan) preselected. Used by product CTAs like "Choose Business" / "Talk to Sales".
 */
export const contactLink = (service = "", plan = "") => {
  const params = new URLSearchParams();
  if (service) params.set("service", service);
  if (plan) params.set("plan", plan);
  const qs = params.toString();
  return `/contact${qs ? `?${qs}` : ""}`;
};
